import { render, staticRenderFns } from "./business-daily.vue?vue&type=template&id=06164c5b&scoped=true&"
import script from "./business-daily.vue?vue&type=script&lang=js&"
export * from "./business-daily.vue?vue&type=script&lang=js&"
import style0 from "./business-daily.vue?vue&type=style&index=0&id=06164c5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06164c5b",
  null
  
)

export default component.exports